import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dvnws1tv58: FaireBrandEntity = {
  token: "b_dvnws1tv58",
  type: "brand",
  name: "Zoey Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/a5e525316e1093dfc1a76177529c90cdce192e132f542039bebbcce185f8c4d4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ebc01d3a77b0806757dec5bec3ee0f67992f5b0a9694b4804e61f5aebe563428.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a5e525316e1093dfc1a76177529c90cdce192e132f542039bebbcce185f8c4d4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ebc01d3a77b0806757dec5bec3ee0f67992f5b0a9694b4804e61f5aebe563428.jpeg",
  location: "Melbourne, FL, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "Like many other brand-new parents, Danny and Kelsey wanted the best for Zoey and had worked very hard so they could offer her the best. There were so many decisions … what kind of bottles, diapers, clothes, toys? What should we put on her skin and hair? They became avid label readers and we were concerned about many of the ingredients that were in traditional baby products like lotions, shampoos, and diaper rash creams.\n\nZoey’s Papa, Charley, who is an innovative pioneer in the skincare industry, has been working with natural products for more than 30 years. So when they were unsatisfied with what was available for children, they asked him to develop products for Zoey that had the same gentleness and effectiveness as Papa’s other lines.\n\nAfter using the products he developed for them, they immediately fell in love and knew they had to share them with others. And that's how Zoey Naturals was born. We are family-owned and believe in the power of community. Based out of Melbourne, Florida, our products are made right here in the USA. \n\nZoey Naturals is formulated to be safe for babies and the environment. Our Sunscreen is reef-safe! Our Skincare is hypoallergenic, paraben-free, phthalate-free, sulfate-free, and naturally scented. \n\nWe love meeting growing families like yours and we warmly welcome you into ours. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:41.121Z",
    importedBy: "entity-db-cli",
  },
};
